import { z } from "zod";

export const templateSchema = z.object({
  type: z.string(),
  name: z.string(),
  id: z.number(),
});
